import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, Inject, OnInit, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { PopUpComponent } from '@shared/components/pop-up/pop-up.component';
import { ProgressbarComponent } from '@shared/components/progressbar/progressbar.component';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';
import { LoadingService } from '@shared/services/loading.service';
import { SwiperService } from '@shared/services/swiper-config.service';
import { SharedModule } from '@shared/shared.module';
import { SwiperComponent } from 'swiper/angular';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { popupDirective } from '@shared/directives/popup.directive';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
;


@Component({
  selector: 'iho-gallery-rooms-modal',
  standalone: true,
  imports: [CommonModule,
    MatCheckboxModule,
    FormsModule,
    SharedModule,
    ProgressbarComponent,
    MatFormFieldModule,
    RialToTomanPipe,
    MatSelectModule,
    PopUpComponent,
    NgOptimizedImage,
    MatDialogModule,
    popupDirective
  ],

  templateUrl: './gallery-rooms-modal.component.html',
  styleUrls: ['./gallery-rooms-modal.component.scss'],
})
export class GalleryRoomsModalComponent implements OnInit {
  modalData: any;
  realIndexSlider = 1;
  showEmpty = false;
  cdr = inject(ChangeDetectorRef)
  responseDetailsRooms?: any;
  cdnUrl = cdnUrl
  destroyRef = inject(DestroyRef)
  @ViewChild('swiperGalleryEl', { static: false }) swiper?: SwiperComponent;
  configSwiperGallery: any;
  constructor(@Inject(MAT_DIALOG_DATA) data: { data: any },
    public InfoService: HotelInfoUiService,
    private swiperService: SwiperService,
    public LoadingService: LoadingService,
    public dialogRef: MatDialogRef<GalleryRoomsModalComponent>) {
    this.modalData = data;
  }
  ngOnInit(): void {



    this.showGetDetailsRooms();
    let config = {
      slide: "auto",
      pagination: {
        enabled: true,
        clickable: false,
      },
      navigation: false,
    }
    this.configSwiperGallery = this.swiperService.SwiperConfig(config);


  }
  closeModal() {
    this.dialogRef.close();

  }

  showGetDetailsRooms() {
    let model = {
      "RoomId": this.modalData.roomId,
      "HotelId": this.modalData.hotelId
    }
    this.LoadingService.loadingState.set(true)

    this.InfoService.getRoomDetails(model).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
      this.responseDetailsRooms = res;
      
        this.LoadingService.loadingState.set(false);

        if(res?.slider?.length == 0){
          this.showEmpty = true;
        }

    })
  }
  onSlideChange(ev: any) {
    this.realIndexSlider = ev[0].realIndex + 1;
    this.cdr.detectChanges()
  }
  senitizeHtmlContent(dom:any){
    const html = dom;

    return html;
  }

}
